let getResponseMail = function() {	
	console.log("getResponseMail", this.getResponseMail);
	if (this.getResponseMail && this.getResponseMail.fEventBus === "invoice-email") {
		this.sendMailInvoice(this.getResponseMail);
	}
};
export default getResponseMail;
